import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const NeighborhoodGuide = () => {
  const nearbyAttractions = [
  {
    name: "Centennial Park",
    distance: "0.5 km",
    description: "Beautiful green space perfect for a post-bakery stroll",
    image: "https://images.unsplash.com/photo-1699539266813-b4b1d0b164c1",
    imageAlt: "Expansive green park with walking paths, mature trees, and families enjoying outdoor activities on sunny day",
    icon: "Trees",
    category: "Park"
  },
  {
    name: "Sherway Gardens",
    distance: "2.1 km",
    description: "Premier shopping destination with 200+ stores",
    image: "https://images.unsplash.com/photo-1678364859787-6b2eff1c88f7",
    imageAlt: "Modern upscale shopping mall interior with bright lighting, multiple retail stores, and shoppers walking through wide corridors",
    icon: "ShoppingBag",
    category: "Shopping"
  },
  {
    name: "Humber Bay Park",
    distance: "3.8 km",
    description: "Waterfront park with stunning lake views",
    image: "https://images.unsplash.com/photo-1555273308-891c3d21b1ca",
    imageAlt: "Scenic waterfront park with blue lake waters, walking trails, and Toronto skyline visible in distance under clear sky",
    icon: "Waves",
    category: "Nature"
  },
  {
    name: "Etobicoke Civic Centre",
    distance: "1.2 km",
    description: "Community hub with library and recreation facilities",
    image: "https://images.unsplash.com/photo-1640398592127-effc66fa143a",
    imageAlt: "Modern civic building with glass facade, concrete architecture, and Canadian flag flying prominently at entrance",
    icon: "Building2",
    category: "Community"
  }];


  const localBusinesses = [
  {
    name: "Italian Specialty Stores",
    description: "Authentic imported goods and ingredients",
    icon: "Store"
  },
  {
    name: "Coffee Shops",
    description: "Perfect complement to our pastries",
    icon: "Coffee"
  },
  {
    name: "Restaurants",
    description: "Diverse dining options nearby",
    icon: "UtensilsCrossed"
  }];


  return (
    <div className="bg-card rounded-2xl overflow-hidden shadow-warm">
      <div className="p-6 border-b border-border">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="MapPin" size={20} color="var(--color-primary)" />
          </div>
          <h2 className="text-2xl font-serif font-semibold text-foreground">
            Explore the Neighborhood
          </h2>
        </div>
        <p className="text-muted-foreground">
          Discover what makes our Etobicoke location special
        </p>
      </div>
      <div className="p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">
          Nearby Attractions
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
          {nearbyAttractions?.map((attraction, index) =>
          <div
            key={index}
            className="group rounded-xl overflow-hidden bg-muted/30 border border-border hover:border-primary/20 transition-all duration-300">

              <div className="relative h-40 overflow-hidden">
                <Image
                src={attraction?.image}
                alt={attraction?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                <div className="absolute top-3 right-3 px-3 py-1 bg-background/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground">
                  {attraction?.distance}
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <Icon name={attraction?.icon} size={18} color="var(--color-primary)" />
                  <h4 className="font-semibold text-foreground">
                    {attraction?.name}
                  </h4>
                </div>
                <p className="text-sm text-muted-foreground mb-2">
                  {attraction?.description}
                </p>
                <span className="inline-block px-2 py-1 bg-primary/10 rounded text-xs font-medium text-primary">
                  {attraction?.category}
                </span>
              </div>
            </div>
          )}
        </div>

        <h3 className="text-lg font-semibold text-foreground mb-4">
          Local Businesses
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          {localBusinesses?.map((business, index) =>
          <div
            key={index}
            className="p-4 rounded-xl bg-muted/30 border border-border text-center">

              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mx-auto mb-3">
                <Icon name={business?.icon} size={22} color="var(--color-primary)" />
              </div>
              <h4 className="font-medium text-foreground mb-1">
                {business?.name}
              </h4>
              <p className="text-sm text-muted-foreground">
                {business?.description}
              </p>
            </div>
          )}
        </div>

        <div className="p-5 bg-gradient-to-br from-primary/5 to-accent/5 rounded-xl border border-primary/10">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Heart" size={22} color="var(--color-primary)" />
            </div>
            <div>
              <h3 className="font-semibold text-foreground mb-2">
                Part of the Community Since 1985
              </h3>
              <p className="text-sm text-muted-foreground">
                We're proud to be a cornerstone of the Etobicoke community, serving authentic Italian baked goods to our neighbors for nearly four decades. Our bakery has become a gathering place where traditions are shared and memories are made.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>);

};

export default NeighborhoodGuide;